import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["btn"];
  static values = { url: String, field: String };

  async save() {
    // Tiptap stores HTML in a hidden input with the field name
    const hiddenInput = this.element.querySelector("input[type='hidden']");
    const value = hiddenInput ? hiddenInput.value : "";

    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]',
    )?.content;

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
        Accept: "text/vnd.turbo-stream.html",
      },
      body: JSON.stringify({
        field: this.fieldValue,
        value: value,
      }),
    });

    if (response.ok) {
      const html = await response.text();
      Turbo.renderStreamMessage(html);
    }
  }
}
